export default "__VITE_ASSET__CXa2hX$g__ 400w, __VITE_ASSET__AOk2f1gv__ 800w, __VITE_ASSET__DquDuxsF__ 1024w";